import { css } from 'styled-components';

export const BASE_FIELD_STYLES = css`
  margin-bottom: 5px;

  &:last-of-type {
    border-bottom: 0;
  }

  .wrapped-comp {
    position: relative;
  }

  .field-error {
  }

  .required {
    color: rgba(255, 51, 92, 1);
  }
`;
